import { useTranslations } from 'next-intl';

export const useExtraTag = () => {
  const t = useTranslations('elements');
  const allTag = {
    id: 'all',
    name: t('allTag'),
  };

  const likeTag = {
    id: '_like',
    name: t('likedTag'),
  };

  const collectTag = {
    id: '_collect',
    name: t('collectedTag'),
  };

  const extraTagMap = {
    [allTag.id]: allTag.name,
    [likeTag.id]: likeTag.name,
    [collectTag.id]: collectTag.name,
  };

  const getExtraTagName = (id: string): string | undefined => {
    return extraTagMap[id];
  };

  return {
    allTag,
    likeTag,
    collectTag,
    getExtraTagName,
  };
};
